/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Api_Keys_Name_LabelInputs */



/**
* | output |
* | --- |
* | "Key Name" |
*
* @param {Options_Api_Keys_Name_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_api_keys_name_label = /** @type {((inputs?: Options_Api_Keys_Name_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Api_Keys_Name_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nom de la clé")
	if (locale === "de") return /** @type {LocalizedString} */ ("Schlüsselname")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nome chiave")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Имя ключа")
	if (locale === "es") return /** @type {LocalizedString} */ ("Nombre de la clave")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("键名")
	if (locale === "ja") return /** @type {LocalizedString} */ ("キー名")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कुंजी नाम")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nome da chave")
	return /** @type {LocalizedString} */ ("Key Name")
});